import { useCallback, useMemo } from 'react';
import { standardizeLocale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export type ComparatorType = (x: string, y: string) => number;

export const useLocaleCompare = (): ComparatorType => {
	const { locale } = useTenantContext();

	const collatorNew = useMemo(
		() => new Intl.Collator(standardizeLocale(locale), { sensitivity: 'base' }),
		[locale],
	);

	const callbackComparator = useCallback(
		(x: string, y: string) => collatorNew.compare(x, y),
		[collatorNew],
	);

	// remove when cleaning up jql_builder_basic_ssr_stability_fixes
	const memoComparator = useMemo(() => {
		const collator = new Intl.Collator(standardizeLocale(locale), { sensitivity: 'base' });
		return collator.compare;
	}, [locale]);

	return fg('jql_builder_basic_ssr_stability_fixes') ? callbackComparator : memoComparator;
};
